@import '../../../../../style/lib/scss';
@import '../../../../../style/src/typography/mixins';
@import '../../../mixins/outline';

:host {
	@include zds-typography('headline-md');

	display: block;
}

.zds-navigation-body-link {
	@include outline;

	align-items: center;
	color: var(--zds-navigation-body-link-color);
	cursor: pointer;
	display: flex;
	font-size: var(--zds-navigation-body-link-size);
	padding: var(--zds-space-4) 0;
	text-decoration: none;
	text-transform: var(--zds-navigation-link-text-transform);
	transition: color var(--zds-transition-sm);

	@include zds-media-breakpoint-up('md') {
		:host([active]) & {
			color: var(--zds-navigation-body-link-color-active);
		}
	}

	&:hover {
		color: var(--zds-navigation-body-link-color-hover);
	}

	&__label {
		flex-grow: 1;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__icon {
		display: flex;
		flex-shrink: 0;
		font-size: var(--zds-navigation-body-link-icon-size);
		margin-right: var(--zds-space-4);

		&-forward {
			font-size: 20px;
			margin-right: 0;
		}
	}
}
